import { useData } from "../context/DataContext";
import { C, G } from "../styles/theme";
import FImg from "../components/common/FImg";
import Avatar from "../components/common/Avatar";

export default function Blog() {
  const { db } = useData();
  const s = db.settings || {};
  const posts = (db.blog || []).filter(b => b.status === "published");

  return (
    <div style={{ background: C.bg }}>
      <div style={{ background: G.hero, padding: "44px 24px 36px", textAlign: "center" }}>
        <span style={{ color: C.orange2, fontSize: 11, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase" }}>Knowledge Hub</span>
        <h1 style={{ fontFamily: "'Playfair Display',Georgia,serif", fontSize: 30, fontWeight: 800, color: "#fff", margin: "11px 0 9px", letterSpacing: "-0.4px" }}>{s.blogHeroTitle || "Blog & Insights"}</h1>
        <p style={{ color: "rgba(255,255,255,.65)", fontSize: 14 }}>Expert articles, application notes and industry news.</p>
      </div>
      <div style={{ padding: "44px 24px" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <div className="grid-3" style={{ gap: 18 }}>
            {posts.map(b => (
              <div key={b.id} className="hl" style={{ background: "#fff", borderRadius: 14, overflow: "hidden", boxShadow: "0 2px 12px rgba(26,60,110,.06)", border: `1px solid ${C.border}`, display: "flex", flexDirection: "column" }}>
                <FImg src={b.image} h={190} placeholder={b.category} style={{ width: "100%", height: 190, objectFit: "cover" }} />
                <div style={{ padding: "14px 16px 18px", flex: 1, display: "flex", flexDirection: "column" }}>
                  <span style={{ background: "rgba(232,89,60,.1)", color: C.orange, padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700, display: "inline-block", width: "fit-content", marginBottom: 8 }}>{b.category}</span>
                  <h4 style={{ fontSize: 14, fontWeight: 700, color: C.blue, margin: "0 0 7px", lineHeight: 1.4, flex: 1 }}>{b.title}</h4>
                  <p style={{ fontSize: 12.5, color: C.gray, lineHeight: 1.55, margin: "0 0 12px" }}>{b.excerpt}</p>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, paddingTop: 9, borderTop: `1px solid ${C.border}` }}>
                    <Avatar src={b.authorImage} name={b.author} size={36} border={false} />
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 12, fontWeight: 700, color: C.blue, overflow: "hidden", textOverflow: "ellipsis" }}>{b.author}</div>
                      <div style={{ fontSize: 10.5, color: C.gray, marginTop: 1 }}>{b.date}</div>
                    </div>
                    <span style={{ fontSize: 10, color: C.gray, flexShrink: 0, whiteSpace: "nowrap" }}>{b.views.toLocaleString()} views</span>
                  </div>
                </div>
              </div>
            ))}
            {!posts.length && <div style={{ gridColumn: "1/-1", textAlign: "center", padding: 44, color: C.gray }}>{s.blogEmptyMsg || "No posts published yet."}</div>}
          </div>
        </div>
      </div>
    </div>
  );
}
